import './process.scss';
import Swiper from 'swiper/bundle';

export default () => {
	new Swiper('.js-process-slider', {
		speed: 500,
		loop: true,
		slidesPerView: 1,
		spaceBetween: 10,
		autoplay: {
			delay: 10000,
		},
	});
};
